const AnsweringServices = [
  {
    title: 'Answering Basic',
    subTitle: 'Include 50 Calls Per month',
    features: [
      'Unique Telephone Number',
      'Immediate Message Notifications',
      'Easy Setup',
      '$1.50 per additional call',
      'Customized Call Handling',
      'Music on Hold',
      'Scalable Plans',
    ],
    price: 'US$50.00',
    duration: 'per month',
    type: 'answering',
    subtype: 'ANSWERING_BASIC',
  },
  {
    title: 'Answering Silver',
    subTitle: 'Include 110 Calls Per month',
    features: [
      'Unique Telephone Number',
      'Email and SMS Alerts',
      'Virtual Phone App',
      'Customized Music on Hold',
      'Customized Call Handling',
      '24/7 Live Coverage',
      'Free Call Patching / Transfers*',
      'Appointment Setting',
    ],
    price: 'US$100.00',
    duration: 'per month',
    type: 'answering',
    subtype: 'ANSWERING_SILVER',
  },
  {
    title: 'Answering Premium',
    subTitle: 'Include 300 Calls Per month',
    features: [
      'Unique Telephone Number',
      'Email and SMS Alerts',
      'Virtual Phone App',
      'Customized Music on Hold',
      'Customized Call Handling',
      '24/7 Live Coverage',
      'Free Call Patching / Transfers*',
      'Appointment Setting',
    ],
    price: 'US$250.00',
    duration: 'per month',
    type: 'answering',
    subtype: 'ANSWERING_PREMIUM',
  },
]

export default AnsweringServices
